import { apiGET, apiPOST } from "../utils/apiHandler";

export const getLitigationClients = async (branchName) => {
    try {
        const response = await apiGET(`/litigation/api/clients/`, { branch_name: branchName });
        return response;
    } catch (error) {
        return error;
    }
};

export const getLitigationBranches = async (clientId) => {
    try {
        const response = await apiGET(`/litigation/api/branches/`, { client__id: clientId });
        return response;
    } catch (error) {
        return error;
    }
};

export const updateAdditionalDetails = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/update/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const createSingleCase = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/create/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const updateDetails = async (body) => {
    try {
        const response = await apiPOST(`litigation/api/case/update-generate/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const getCase = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/cases`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const getMissingFields= async (params) => {
    try {
        const response = await apiGET(`litigation/api/case/missing/data/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const postBatchData = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/bulk_create/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const batchListingAPI = async (params) => {
    try{
        const response = await apiGET('/litigation/api/litigation_batch/list/', params);
        return response
    } catch (error) {
        return error;
    }
}

export const updateEFiling = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/cases/update_case_number/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const addPocketExpance = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/expenses/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const caseDocumentUpload = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/case/document/`, body);
        return response;
    } catch (error) {
        return error;
    }
};

export const generateSample = async (params) => {
    try {
        const response = await apiPOST(`/litigation/api/case/document/sample/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const approveSample = async (params) => {
    try {
        const response = await apiPOST(`/litigation/api/case/documents/generate/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const sendSample = async (params) => {
    try {
        const response = await apiPOST(`/litigation/api/case/document/generate/client`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const expanceListingAPI = async (params) => {
    try{
        const response = await apiGET(`/litigation/api/case/expenses/list/`, params);
        return response;
    } catch (error) {
        return error;
    }
}

export const caseDocumentDownload = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/case/document/list/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

export const getCasesMailHistory = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/case/email/conversations/`, params);
        return response;
    } catch (error) {
        return error;
    }
};
///litigation/api/request_court_fee/  get
export const requestCourtFee = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/request_court_fee/`, params);
        return response;
    } catch (error) {
        return error;
    }
};

//Add Comment  - /litigation/api/add_comment/ - POST API
export const addComment = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/add_comments/`, body);
        return response;
    } catch (error) {
        return error;
    }
}

//Comment GET API - /litigation/api/get_comments/ - GET API
export const getComments = async (caseId) => {
    try {
        const response = await apiGET(`/litigation/api/get_comments/`, { case_id: caseId });
        return response;
    } catch (error) {
        return error;
    }
}

//List Invoice GET API - /litigation/api/list/case/invoices - GET API
export const listInvoice = async (params) => {
    try {
        const response = await apiGET(`/litigation/api/list/case/invoices`, params);
        return response;
    } catch (error) {
        return error;
    }
}

//Create Invoice POST API - /litigation/api/create/case/invoice - POST API
export const createInvoice = async (body) => {
    try {
        const response = await apiPOST(`/litigation/api/create/case/invoice`, body);
        return response;
    } catch (error) {
        return error;
    }
}

export const getLitigationCaseTypes = async () => {
    try {
        const response = await apiGET(`/litigation/api/cases`);
        return response;
    } catch (error) {
        return error;
    }
};

{/* clientListingAPI */}
export const clientListingAPI = async (params) => {
    try{
        const response = await apiGET('/litigation/api/clients/cases/', params);
        return response
    } catch (error) {
        return error;
    }
}